export const Data=[
    {
        whatIDo:"What I Do",
        fed:"FRONT-END DEVELOPER",
        gd:"GRAPHIC DESIGNER",
        bb:"BUSSINESS BRANDING",
        cons:"CONSULTANCY",
    }
]